/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboPostsentineloneaccountsPostSentinelOneAccountsRequestBody
 */
export interface JumboPostsentineloneaccountsPostSentinelOneAccountsRequestBody {
    /**
     * 
     * @type {string}
     * @memberof JumboPostsentineloneaccountsPostSentinelOneAccountsRequestBody
     */
    accessToken: string;
    /**
     * 
     * @type {string}
     * @memberof JumboPostsentineloneaccountsPostSentinelOneAccountsRequestBody
     */
    sentinelOneManagementURL: string;
}

/**
 * Check if a given object implements the JumboPostsentineloneaccountsPostSentinelOneAccountsRequestBody interface.
 */
export function instanceOfJumboPostsentineloneaccountsPostSentinelOneAccountsRequestBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "accessToken" in value;
    isInstance = isInstance && "sentinelOneManagementURL" in value;

    return isInstance;
}

export function JumboPostsentineloneaccountsPostSentinelOneAccountsRequestBodyFromJSON(json: any): JumboPostsentineloneaccountsPostSentinelOneAccountsRequestBody {
    return JumboPostsentineloneaccountsPostSentinelOneAccountsRequestBodyFromJSONTyped(json, false);
}

export function JumboPostsentineloneaccountsPostSentinelOneAccountsRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboPostsentineloneaccountsPostSentinelOneAccountsRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accessToken': json['accessToken'],
        'sentinelOneManagementURL': json['sentinelOneManagementURL'],
    };
}

export function JumboPostsentineloneaccountsPostSentinelOneAccountsRequestBodyToJSON(value?: JumboPostsentineloneaccountsPostSentinelOneAccountsRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accessToken': value.accessToken,
        'sentinelOneManagementURL': value.sentinelOneManagementURL,
    };
}

